import React from 'react';
import { noop } from 'lodash';
import { func } from 'prop-types';
import { Icon } from '@fiverr-private/fit';
import { r_search } from '@fiverr-private/icons';
import { I18n } from '@fiverr-private/i18n-react';
import { isMacOS } from '../../../utils/environment';
import './style.scss';

export const KEYBOARD_SHORTCUTS = {
    MAC: '⌘/',
    NON_MAC: '^/',
};

const QuickSearchLink = ({ onClick = noop }) => (
    <div className="quick-search-nav nav-link" onClick={onClick}>
        <div>
            <Icon className="quick-search-icon" size={16}>
                {r_search}
            </Icon>
            <span className="p-l-8">
                <I18n k="header.quick_search" />
            </span>
        </div>
        <span className="quick-search-shortcut p-l-8">
            {isMacOS() ? KEYBOARD_SHORTCUTS.MAC : KEYBOARD_SHORTCUTS.NON_MAC}
        </span>
    </div>
);

QuickSearchLink.propTypes = {
    onClick: func,
};

export default QuickSearchLink;
